const en_companyProfile = {
    "": "company profile",
    account: "account name",
    address: "company address",
    code: "company code",
    email: "company email",
    fax: "company fax",
    id: "company ID",
    logo: "company logo",
    name: "company name",
    phone: "company phone",
    tax: "tax number",

    error: {
        code: "Company code cannot be empty.",
        name: "Company name cannot be empty.",
        address: "Company address cannot be empty.",
        update: "Failed to update company information.",
        pass: "Failed to change password."
    },

    success: {
        update: "Company information updated successfully.",
        pass: "Password changed successfully."
    },
}

export default en_companyProfile;